import styled from 'styled-components'
import { motion } from 'framer-motion'

const Card = styled(motion.div)`
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  overflow: hidden;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: var(--color-accent);
  }
`

const Photo = styled.div`
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
  background: var(--color-bg-elevated);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
  }

  ${Card}:hover & img {
    transform: scale(1.05);
  }
`

const Info = styled.div`
  padding: 20px;
`

const Name = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 4px;
`

const Role = styled.p`
  font-size: 0.85rem;
  color: var(--color-accent);
  font-weight: 500;
  margin-bottom: 12px;
`

const Bio = styled.p`
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  line-height: 1.6;
`

const LinkedInLink = styled.a`
  display: inline-block;
  margin-top: 12px;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--color-text-muted);
  transition: color 0.2s ease;

  &:hover {
    color: var(--color-accent);
  }
`

export default function TeamMemberCard({ name, role, bio, photo, linkedin, delay = 0 }) {
  return (
    <Card
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay }}
    >
      {photo && (
        <Photo>
          <img src={photo} alt={name} loading="lazy" />
        </Photo>
      )}
      <Info>
        <Name>{name}</Name>
        <Role>{role}</Role>
        <Bio>{bio}</Bio>
        {linkedin && (
          <LinkedInLink href={linkedin} target="_blank" rel="noopener noreferrer">
            LinkedIn &rarr;
          </LinkedInLink>
        )}
      </Info>
    </Card>
  )
}
